import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class H8Overlay extends Vue {
  @Prop({ default: false }) public isVisible: boolean;
  @Prop({ default: '' }) public loadingText: string;
}
